import React, { useState, useRef } from 'react';
import {
  Card,
  CardBody,
  Button,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import DataHandler from '../../../services/DataHandler';
import { useTranslation } from 'react-i18next';

const RegistroCuentaPaso5Activacion = ({ registrationId, onFinish }) => {
  const navigate = useNavigate();

  // Estados para cada dígito (código de 6 cifras)
  const [digits, setDigits] = useState(Array(6).fill(''));
  const inputsRef = useRef([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // i18n – namespace "activation"
  const { t } = useTranslation('activation');

  // 🔒 Validación: todos los dígitos deben estar completos
  // (no usamos Formik/Yup aquí; la validación se hace a mano sobre `digits`)
  // const validationSchema = Yup.object({});

  // Cuando cambias un dígito
  const handleChange = (idx, val) => {
    // sólo permite un dígito numérico o vacío
    if (!/^\d?$/.test(val)) return;

    const newDigits = [...digits];
    newDigits[idx] = val;
    setDigits(newDigits);

    // si se escribe algo y no es el último, enfocar el siguiente input
    if (val && idx < 5) {
      inputsRef.current[idx + 1]?.focus();
    }
  };
const handleKeyDown = (idx, e) => {
  if (e.key === 'Backspace' && !digits[idx] && idx > 0) {
    inputsRef.current[idx - 1].focus();
  }
};

  const code = digits.join('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Si no tiene los 6 dígitos, mostramos error
    if (code.length < 6) {
      setErrorMessage(t('step5.errors.code6Digits'));
      setShowErrorModal(true);
      return;
    }

    try {
      const dh = new DataHandler(
        'POSTREGISTROVALIDACION',
        { id: registrationId },
        null,
        () => { },
        () => { },
        () => { }
      );

      const payload = { id: registrationId, codigo: code };
      const result = await dh.postData(payload);

      if (result.succeeded) {
        // Éxito → mostramos modal de activación correcta
        setShowSuccessModal(true);
      } else {
        // Error de negocio: mensaje del backend o texto genérico
        setErrorMessage(result.message || t('step5.errors.invalidCode'));
        setShowErrorModal(true);
      }
    } catch (err) {
      // Error de red / excepciones
      setErrorMessage(err.message || t('step5.errors.connectionError'));
      setShowErrorModal(true);
    }
  };

  return (
    <>
      <Card className="shadow-sm">
        <CardBody>
          {/* Título del paso */}
          <h5 className="mb-4">{t('step5.title')}</h5>

          <form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>{t('step5.activationCodeLabel')}</Label>
              <Row className="justify-content-center mb-3">
                {digits.map((d, i) => (
                  <Col xs="2" sm="1" key={i} className="px-1">
                    <input
                      type="text"
                      inputMode="numeric"
                      maxLength="1"
                      className="form-control text-center fs-4"
                      value={d}
                      onChange={e => handleChange(i, e.target.value)}
                      ref={el => (inputsRef.current[i] = el)}
                      style={{
                        borderRadius: '0.5rem',
                        backgroundColor: '#fff',
                        color: '#000',
                        width: '100%',
                        height: '3.5rem',
                        padding: 0,
                        minWidth: '40px',
                        fontSize: 'clamp(1.2rem, 3vw, 1.8rem)',
                      }}
                    />
                  </Col>
                ))}
              </Row>

              {/* Si quisieras usar ErrorMessage en un futuro, lo puedes reactivar aquí */}
              {/* <ErrorMessage name="codigo" component="div" className="text-danger small mt-1" /> */}
            </FormGroup>

            <Button type="submit" color="primary" block>
              {t('step5.submitButton')}
            </Button>
          </form>
        </CardBody>
      </Card>

      {/* Modal de Error */}
      <Modal isOpen={showErrorModal} toggle={() => setShowErrorModal(false)}>
        <ModalHeader toggle={() => setShowErrorModal(false)}>
          {t('step5.errorModal.title')}
        </ModalHeader>
        <ModalBody>{errorMessage}</ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setShowErrorModal(false)}>
            {t('step5.errorModal.close')}
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal de Éxito */}
      <Modal isOpen={showSuccessModal} toggle={() => setShowSuccessModal(false)}>
        <ModalHeader toggle={() => setShowSuccessModal(false)}>
          {t('step5.successModal.title')}
        </ModalHeader>
        <ModalBody>{t('step5.successModal.body')}</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() => {
              setShowSuccessModal(false);
              // Opcionalmente podrías llamar onFinish?.();
              navigate('/auth/login', { replace: true });
            }}
          >
            {t('step5.successModal.goToLogin')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default RegistroCuentaPaso5Activacion;
